import {
  filter,
  tap,
  ignoreElements,
  switchMap,
  mergeMap,
  catchError,
} from 'rxjs/operators'
import {of, concat, from} from 'rxjs'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {SettingsService} from 'services/api'
import Toast from 'components/Basic/Toast'
import {settingsActions} from '../settingsSlice'
import {toast} from 'react-toastify'
import {settingErrorToast} from 'definitions/constant'
import {i18n} from 'i18n'

const {t} = i18n

const updateDefaultBlockPagesEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.defaultBlockPagesUpdate.match),
    switchMap(({payload}) =>
      from(SettingsService.updateDefaultBlockPages(payload)).pipe(
        mergeMap(() => [settingsActions.defaultBlockPagesUpdateSuccess()]),
        catchError((message: string) =>
          concat(of(settingsActions.defaultBlockPagesUpdateFailure(message))),
        ),
      ),
    ),
  )

const defaultBlockPagesUpdateSuccessEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.defaultBlockPagesUpdateSuccess.match),
    tap(() => {
      Toast({message: 'Block Pages Updated', type: 'success'})
    }),
    ignoreElements(),
  )

const updateCustomBlockPagesEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.customBlockPagesUpdate.match),
    switchMap(payload =>
      from(SettingsService.updateCustomBlockPages(payload.payload)).pipe(
        mergeMap(() => [settingsActions.customBlockPagesUpdateSuccess()]),
        catchError((message: string) =>
          concat(of(settingsActions.customBlockPagesUpdateFailure(message))),
        ),
      ),
    ),
  )

const updateCustomBlockSuccessEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.customBlockPagesUpdateSuccess.match),
    tap(() => {
      Toast({message: 'Block Pages Updated', type: 'success'})
    }),
    ignoreElements(),
  )

const updatePolicyUpdateFieldEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.updateSettingField.match),
    tap(({payload}) => {
      if (
        payload?.throwError &&
        payload.value &&
        !toast.isActive(settingErrorToast)
      ) {
        Toast({
          message: t('common:TAB_ENTER_ERROR'),
          type: 'error',
          customId: settingErrorToast,
        })
      }
    }),
    ignoreElements(),
  )

export const blockPagesEpics = [
  updateDefaultBlockPagesEpic,
  defaultBlockPagesUpdateSuccessEpic,
  updateCustomBlockPagesEpic,
  updateCustomBlockSuccessEpic,
  updatePolicyUpdateFieldEpic,
]
